import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { Body, Box, Button, Dialog, H3 } from '../'

export const DeleteAccountDialog = ({ open, onClose }) => {
  const { user: { email, name } } = useView('tenant')

  const request = useRequest('tenant')
  const [deleted, setDeleted] = useState(false)
  const deleteAccount = () => request('accountDeletionRequested', { email, name }).then(() => setDeleted(true))

  return (
    <Dialog open={open} onClose={onClose} showControls={false} mobileBackground="white" mobileDrawer={false}>
      {(deleted
          ? <>
              <H3 color="black">Delete account</H3>
              <Body color="black">Your request has been raised and your account will be deleted soon.</Body>
            </>
          : <>
              <H3 color="black">Delete account</H3>
              <Body color="black">
                Are you sure you want to delete yor account?<br/>
                All your account data will be permanently deleted.
              </Body>
            </>
      )}
      <Box fullWidth gap={16}>
        <Button light={!deleted} onClick={onClose} fullWidth>
          {deleted ? 'Close' : 'Cancel'}
        </Button>
        {!deleted &&
          <Button onClick={deleteAccount} fullWidth>
            Yes, delete
          </Button>
        }
      </Box>
    </Dialog>
  )
}